// extracted by mini-css-extract-plugin
export var actionButton = "_mq-0";
export var actionMenuContainer = "_mq-i";
export var bubble = "_mq-2";
export var bubbleActionMenu = "_mq-j";
export var bubbleContext = "_mq-6";
export var bubbleItems = "_mq-7";
export var customer = "_mq-3";
export var divider = "_mq-8";
export var fileList = "_mq-9";
export var hiddenComment = "_mq-o";
export var infoAbove = "_mq-a";
export var internal = "_mq-4";
export var lightActionButton = "_mq-1";
export var link = "_mq-b";
export var merchant = "_mq-5";
export var message = "_mq-c";
export var profilePicture = "_mq-e";
export var quillToolbarContainer = "_mq-f";
export var senderDate = "_mq-g";
export var senderDateCustomer = "_mq-h";
export var senderName = "_mq-d";
export var time = "_mq-k";
export var uploadedImage = "_mq-l";
export var username = "_mq-m";
export var xsmall = "_mq-n";